export default "__VITE_ASSET__dc78891e__"